// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"beb90d57","312":"ba7f13fd","386":"835815f5","449":"e9edc640","538":"1733d07e","544":"2be63491","568":"d21c683a","703":"acfb2ea3","722":"3dd60547","970":"41d02ae2"}[chunkId] + ".chunk.js";
};